module.exports = __webpack_public_path__ + "static/media/cows-bg.5de9c6ce.svg";